import React from 'react';
import { useLocation } from 'react-router-dom';
import { PhoneIcon } from '@heroicons/react/24/solid';
import { useLanguage } from '../contexts/LanguageContext';
import { findRouteByPath } from '../seo/routes';

// Schwebender Notruf. Bewusst ein einziges Element und kein Menü: im Notfall
// zählt ein Tipp auf „anrufen", nicht der Weg auf eine Unterseite. Der Notdienst
// selbst ist über Kopfzeile und Fußzeile verlinkt — ein zusätzlicher
// schwebender Link dorthin war nur Dopplung.
//
// Mobil rendert der Knopf als rundes Icon: dort wählt ein Tipp ohnehin, die
// ausgeschriebene Nummer kostet nur Platz neben dem SmartAI-Panel (unten
// links). Ab Tablet steht die Nummer ausgeschrieben da — am Rechner lässt sich
// nicht tippen, dort ist die lesbare Nummer der eigentliche Nutzen.
const EmergencyButton: React.FC = () => {
  const { translations } = useLanguage();
  const location = useLocation();

  // Die Notfall-Spoke-Seiten (Zahnschmerzen/Abszess/abgebrochener Zahn/Touristen)
  // haben mobil bereits eine eigene volle Anruf-/WhatsApp-Leiste am unteren Rand
  // (EmergencySpokePage.tsx). Diese schwebende Pille würde sich dort mit der
  // Leiste überlagern — auf Mobilgeräten deshalb dort ausblenden, auf Desktop
  // und allen übrigen Seiten unverändert anzeigen.
  const routeKey = findRouteByPath(location.pathname)?.key;
  const hidesOnMobile = !!routeKey && routeKey.startsWith('emergency-');

  const label = translations.emergency?.common?.callNow
    || translations.emergency?.call
    || 'Notfall: 603 31 96 48';

  return (
    // emergency-fab: mobil ausgeblendet, sobald das SmartAI-Dock den Notruf
    // als Segment mitführt (index.css, html[data-smartai-dock]).
    <div className={`emergency-fab fixed bottom-4 right-4 z-50 ${hidesOnMobile ? 'hidden md:block' : 'block'}`}>
      <a
        href="tel:+34603319648"
        aria-label={label}
        title={label}
        className="flex items-center justify-center h-14 w-14 sm:h-auto sm:w-auto sm:py-2.5 sm:px-4 bg-coral text-white hover:bg-coral/90 rounded-full shadow-lg border-2 border-white animate-emergencyPulse transition-transform duration-300 hover:scale-105"
      >
        <PhoneIcon className="w-6 h-6 sm:w-5 sm:h-5 sm:mr-1.5" aria-hidden="true" />
        <span className="hidden sm:inline font-bold">603 31 96 48</span>
      </a>
    </div>
  );
};

export default EmergencyButton;
